import useAxiosInterceptor from 'src/services/interceptor';
import { apiPath } from '../constants';

class ContractService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }
  getContractCount = () => {
    return this.axiosInstance.get(`${apiPath.GET_CONTRACT_COUNT}`);
  };
}

const contractService = new ContractService();

Object.freeze(contractService);

export default contractService;
